let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ci0xn")).then(() => parcelRequire('1Cv5i'));